import { configureStore } from "@reduxjs/toolkit";
import { sanitizeReduxActionForDevtools } from "./devToolsSanitizer";
import authReducer from "./slices/authSlice";
import counterSlice from "./slices/counterSlice";
import loaderReducer from "./slices/loaderSlice";
import searchReducer from "./slices/searchSlice";
import userReducer from "./slices/userSlice";
import itemReducer from "./slices/itemSlice";
import adminReducer from "./slices/adminSlice";
import locationReducer from "./slices/locationSlice";
import reportReducer from "./slices/reportSlice";
import categoryReducer from "./slices/categorySlice";
import conditionReducer from "./slices/conditionSlice";
import notificationReducer from "./slices/notificationSlice";
import chatReducer from "./slices/chatSlice";

export const store = configureStore({
  devTools: {
    actionSanitizer: sanitizeReduxActionForDevtools,
  },
  reducer: {
    admin: adminReducer,
    auth: authReducer,
    counter: counterSlice,
    pageLoader: loaderReducer,
    search: searchReducer,
    user: userReducer,
    item: itemReducer,
    location: locationReducer,
    report: reportReducer,
    category: categoryReducer,
    condition: conditionReducer,
    notification: notificationReducer,
    chat: chatReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
